import {
    ACTION_SET_CONFIRM

} from './actions'


export default {
    confirm(state={show:false,msg:'',cancel_txt:'',confirm_txt:'',btn_color_rever:false,cancel:()=>{},confirm:()=>{}}, action) {
        const { type, payload } = action;
        switch (type) {
            case ACTION_SET_CONFIRM:
                return {
                    ...state,
                    ...payload
                };
        }
        return state;
    },

}